
const Page404 = () => (
  <div>
    <h1>404</h1>
  </div>
)

export default Page404
